import { FontSize200, ColorWhite, ColorGray800 } from "@nxt-costco-com/forge-design-tokens";
import { ButtonContainerCompactStyles, ButtonContainerStyles } from "../SwatchButton/styles.js";
const containerStyles = {
  ...ButtonContainerStyles,
  ...ButtonContainerCompactStyles,
  ":hover, :focus": {
    backgroundColor: ColorGray800,
    textDecoration: "none"
  },
  backgroundColor: ColorGray800,
  color: ColorWhite,
  display: "inline-flex",
  fontSize: FontSize200
};
export {
  containerStyles
};
